import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const DriverIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <circle cx="8" cy="8" r="8" fill={props.fill} />
      <path
        d="M9.99975 9.5965L9.99825 10H0.00223056L0.000230652 9.5835C-0.00426913 8.4715 0.0442285 7.836 1.32367 7.5405C2.7261 7.217 4.11003 6.927 3.44457 5.6995C1.47316 2.062 2.88309 0 4.99999 0C7.07639 0 8.52132 1.9855 6.55492 5.699C5.90895 6.919 7.24239 7.209 8.67582 7.54C9.96076 7.837 10.0043 8.4765 9.99975 9.5965Z"
        fill={props.color || "black"}
        transform="translate(3,3)"
      />
    </SvgIcon>
  );
});
